import React from 'react'
import {
  CFImage,
  CFView,
  CFText,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import ViewMenu from './ViewMenu'
import {
  hero,
  heroText,
  logo,
  mobileHero,
  mobileHeroText,
  mobileLogo,
} from 'images'
import ViewMenuButton from './ViewMenuButton'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="105vh"
          maxHeight="750px"
          w="100%"
          image={`url(${mobileHero}) center / cover no-repeat`}
          column
          justifyBetween
          alignCenter
        >
          <CFImage
            src={mobileHeroText}
            w="100%"
            maxWidth="230px"
            mt="10px"
            alt="About"
          />
          <CFView column center textCenter mb="25px">
            <CFView pulsate textCenter w="75%">
              <OrderPickupButton />
            </CFView>
            <CFView textCenter pt="10px" w="75%">
              <OrderDeliveryButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="690px"
          w="100%"
          image={`url(${hero}) center / cover no-repeat`}
          zIndex={90}
          column
          justifyBetween
          alignCenter
        >
          <Header />
          <CFView row center bg="rgba(0,0,0,0.8)" pt="6px" ph="50px" pv="5px">
            <CFText white bold style={{ fontSize: 30 }}>
              Celebrating 25 Years in Vernon BC
            </CFText>
            <CFView pulsate ml="25px" mt="5px">
              <OrderPickupButton />
            </CFView>
            <CFView ml="25px" mt="5px">
              <OrderDeliveryButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
